import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { WithdrawalProductType } from '@generated/generatedEntities';

@Component({
  selector: 'app-effortplanner',
  templateUrl: './effortplanner.component.html',
})
export class EffortplannerComponent {
  private router = inject(Router);
  @Input() isAuthenticated!: boolean;
  @Input() hasEffortPlanner!: boolean;
  @Output() openBillingModal = new EventEmitter<WithdrawalProductType>();

  openBillingModalForEffortPlanner() {
    this.openBillingModal.emit('EFFORT_PLANNER');
  }

  goToInfo() {
    this.router.navigate([]).then(() => {
      window.open('/info-effortplanner', '_blank');
    });
  }

  goToProcessForm() {
    this.router.navigate(['/effort-planner-form/input']);
  }
}
